import React, { useEffect, useState } from "react";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import Style from "./Supplier.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import { ChevronLeft } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import Button from "../../Components/Button/Button";
import Resizer from "react-image-file-resizer";
import {
  getSupplierPAgeAPi,
  sendSupplierInfoApi,
} from "../../Api/BarestSupplierServices";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import { faClock } from "@fortawesome/free-regular-svg-icons"; 
import "./Supplier.css";
const Supplier = () => {
  const week = [
    "شنبه",
    "یکشنبه",
    "دوشنبه",
    "سه شنبه",
    "چهارشنبه",
    "پنجشنبه",
    "جمعه",
  ];
  const { register, handleSubmit } = useForm();
  const [dataHours, setDataHours] = useState([]);
  const [ontimeCover, setOntimeCover] = useState("");
  const [ontimeLogo, setOntimeLogo] = useState("");
  const [openApi, setOpenApi] = useState();
  const [cover, setCover] = useState();
  const [logo, setLogo] = useState();
  const [open, setOpen] = useState(openApi);
  const [openCloseOpen, setOpenCloseOpen] = useState(false);
  const [openWorkHour, setOpenWorkHour] = useState(true);
  const [openUploadImg, setOpenUploadImg] = useState(false);
  const [openAboutUs, setOpenAboutUs] = useState(false);

  useEffect(() => {
    getWorkingHour();

    setOpen(openApi === "0" ? false : true);
  }, [openApi]);

  /////برای قسمت باز و بسته
  const openHandler = () => {
    setOpen(!open);
  };
  const getWorkingHour = async () => {
    const result = await getSupplierPAgeAPi();
    setDataHours(result.supplier_working_hours);
    setCover(result.image.cover);
    setLogo(result.image.logo);
    setOpenApi(result.open);
  };
  //////آپلود کردن عکس پس زمینه
  const UploadCover = async (image) => {
    return await resizeFile(image);
  };

  //////آپلود کردن عکس لوگو
  const UploadLogo = async (image) => {
    return await resizeFileLogo(image);
  };

  /////ریسایز کردن cover برای آپلود
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setOntimeCover(uri);
        },
        "base64"
      );
    });
  /////ریسایز کردن logo برای آپلود
  const resizeFileLogo = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setOntimeLogo(uri);
        },
        "base64"
      );
    });
  const onSubmit = (data) => {
    let startTime1 = [];
    let startTime2 = [];
    let endTime1 = [];
    let endTime2 = [];
    for (let i = 0; i < 7; i++) {
      startTime1.push(data.start1[i]);
      endTime1.push(data.end1[i]);
      startTime2.push(data.start2[i]);
      endTime2.push(data.end2[i]);
    }
    let info = {
      logo: ontimeLogo ? ontimeLogo : "",
      cover: ontimeCover ? ontimeCover : "",
      open: open ? "1" : "0",
      about_us:data.about,
      start_1: startTime1,
      end_1: endTime1,
      start_2: startTime2,
      end_2: endTime2,
    };
    console.log(info)
    sendSupplierInfoApi(info, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت ارسال شد");
      } else {
        errorToast(res.message);
      }
    });
  };

  const openTabHandler = (id) => {
    if (id === 1) {
      setOpenCloseOpen(!openCloseOpen);
    } else if (id === 2) {
      setOpenWorkHour(!openWorkHour);
    } else if (id === 3) {
      setOpenUploadImg(!openUploadImg);
    } else if (id === 4) {
      setOpenAboutUs(!openAboutUs);
    }
  };
  return (
    <div className={Style.pageHolder}>
      <MenuTitle title={"وضعیت تامین کننده"} />
      <div className={Style.picHolder}>
        <img src={"/Assets/Images/supplier/store.png"} alt="" />
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className={Style.Center}>
        <div className={openCloseOpen?Style.openTab:Style.tabs} onClick={() => openTabHandler(1)}>
          <ChevronLeft />
          <h3 className={Style.textTabs}>وضعیت فروشگاه</h3>
        </div>
        {openCloseOpen ? (
          <section className={Style.conditionHolder}>
            <div className={Style.Condition}>
              <div
                onClick={openHandler}
                style={{ borderRadius: ".3rem 0  0 .3rem " }}
                className={open ? Style.true : Style.false}
              >
                باز
              </div>
              <div
                onClick={openHandler}
                style={{ borderRadius: "0 .3rem .3rem 0 " }}
                className={open ? Style.false : Style.true}
              >
                بسته
              </div>
            </div>
            <h3 className={Style.text}>شرایط باز و بسته بودن: </h3>
          </section>
        ) : null}
        <div className={openWorkHour?Style.openTab:Style.tabs} onClick={() => openTabHandler(2)}>
          <ChevronLeft />
          <h3 className={Style.textTabs}>ساعت کاری فروشگاه</h3>
        </div>
        {openWorkHour?
        <div className={Style.workHourHolder}>
          {dataHours.map((item, index) => {
                return (
                  <div key={index} className={Style.hourWork}>
                    <div className={Style.hourWorkPart}>
                      <p className={Style.hourWorkTitle}>
                        <FontAwesomeIcon
                          className={Style.clockIcon}
                          icon={faClock}
                        />
                        تعیین ساعت کاری {week[index]}
                      </p>
                      <div className={Style.firstShift}>
                        <h3 className={Style.titr1shift}>شیفت اول :</h3>
                        <div className={Style.shiftTime}>
                          <h3 className={Style.until}>از ساعت</h3>
                          <input
                            {...register(`start1[${index}]`)}
                            type={"time"}
                            defaultValue={item.start_1}
                          />
                          <span className={Style.until}>تا</span>
                          <input
                            {...register(`end1[${index}]`)}
                            type={"time"}
                            defaultValue={item.end_1}
                          />
                        </div>
                      </div>
                      <div className={Style.firstShift}>
                        <h3 className={Style.titr1shift}> شیفت دوم :</h3>
                        <div className={Style.shiftTime}>
                          <h3 className={Style.until}>از ساعت</h3>
                          <input
                            {...register(`start2[${index}]`)}
                            type={"time"}
                            defaultValue={item.start_2}
                          />
                          <span className={Style.until}>تا</span>
                          <input
                            {...register(`end2[${index}]`)}
                            type={"time"}
                            defaultValue={item.end_2}
                          />
                        </div>
                      </div>
                      <h3 className={Style.notice}>
                        در صورت داشتن شیفت دوم ، ساعت کاری را مشخص کنید
                        <span style={{ color: "#C20C64", fontSize: "1.5rem" }}>
                          *
                        </span>
                      </h3>
                    </div>
                  </div>
                );
              })
             }
        </div>:null}
        <div className={openUploadImg?Style.openTab:Style.tabs} onClick={() => openTabHandler(3)}>
          <ChevronLeft />
          <h3 className={Style.textTabs}>آپلود تصاویر</h3>
        </div>
        {openUploadImg ? (
          <>
            <section className={Style.uploadBackground}>
              <div className={Style.uploadTitle}>آپلود تصویر پس زمینه</div>
              {ontimeCover ? (
                <div className={Style.uploadPart}>
                  <img src={ontimeCover} alt="" />
                </div>
              ) : (
                <div className={Style.uploadPart}>
                  <img
                    src={`https://cdn.barest.ir/supplier/cover/${cover}.jpg`}
                    alt=""
                  />
                </div>
              )}
              <div className={Style.imageUpload}>
                <h3 className={Style.title}>بارگذاری تصویر</h3>
                <input
                  id={"uploadBack"}
                  type="file"
                  style={{ display: "none" }}
                  onChange={(e) => UploadCover(e.target.files[0])}
                />
                <label htmlFor={"uploadBack"} className={Style.iconHolder}>
                  <FontAwesomeIcon className={Style.icon} icon={faImage} />
                </label>
              </div>
            </section>
            <section className={Style.logoPart}>
              <div className={Style.titleLogo}>بارگذاری لوگو</div>
              {ontimeLogo ? (
                <div className={Style.uploadImage}>
                  <img src={ontimeLogo} alt="" />
                </div>
              ) : (
                <div className={Style.uploadImage}>
                  <img
                    src={`https://cdn.barest.ir/supplier/logo/${logo}.jpg`}
                    alt=""
                  />
                </div>
              )}
              <input
                id={"uploadLogo"}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => UploadLogo(e.target.files[0])}
              />
              <label htmlFor={"uploadLogo"} className={Style.iconHolder}>
                <FontAwesomeIcon className={Style.icon} icon={faImage} />
              </label>
              <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
            </section>
          </>
        ) : null}
        <div className={openAboutUs?Style.openTab:Style.tabs} onClick={() => openTabHandler(4)}>
          <ChevronLeft />
          <h3 className={Style.textTabs}> اضافه کردن درباره ما</h3>
        </div>
        {openAboutUs?
          <div className={Style.aboutUsHolder}>
            <textarea {...register('about')} placeholder={"درباره کسب و کارتان توضیح دهید"} className={Style.aboutUs}/>
          </div>
          :null
        }
        <div className={Style.btnHolder}>
          <Button
            ClassBtn={"bigConfirmBtn"}
            Value={"ثبت"}
          />
        </div>
      </form>
    </div>
  );
};
export default Supplier;
